<template>
<div ref="option" class="nd-option" @click="optionClick">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: 'NdOption',

  data () {
    return {
    }
  },

  methods: {
    optionClick (e) {
//      console.log('Click on Option')
//      console.log(this.$refs.option.innerText)
//      console.log(e.target)
      this.$refs.option.dispatchEvent(new CustomEvent('select', {
        bubbles: true,
        detail: this.$refs.option.innerText
      }))
    }
  }
}
</script>

<style lang="scss" scoped>

.nd-option {
  height: 25px;
  line-height: 25px;
  cursor: pointer;
  background-color: white;
  padding: 0px 5px;
  font-weight: normal;
}

.nd-option:hover {
  background-color: #eeeeee;
  font-weight: bold;
}

</style>
